import type { RouteRecordRaw } from 'vue-router';

const MainLayout = () => import('@/shared/layouts/pages/MainLayout/index.vue');

const ContactsPage = () =>
  import('@/modules/contacts/pages/ContactBook/index.vue');
const ListsContactsPage = () =>
  import('@/modules/contacts/pages/ContactListsMain/index.vue');
const ListPreviewPage = () =>
  import('@/modules/contacts/pages/ContactListsPreview/index.vue');
const ListDetailPage = () =>
  import('@/modules/contacts/pages/ContactListsDetail/index.vue');

export const contactsPrivateRoutes: Array<RouteRecordRaw> = [
  {
    path: '/contacts',
    name: 'contacts',
    component: MainLayout,
    redirect: {
      name: 'contacts-index',
    },
    children: [
      {
        path: '',
        name: 'contacts-index',
        component: ContactsPage,
        meta: {
          title: 'Contactos',
          accessRol: {
            section: 'CONTACTS',
            actions: ['VIEW'],
          },
        },
      },
    ],
  },
  {
    path: '/lists-contacts',
    component: MainLayout,
    children: [
      {
        path: '',
        name: 'lists-contacts',
        component: ListsContactsPage,
        meta: {
          requiresAuth: true,
          title: 'Lists Contacts',
        },
      },
      {
        path: '/lists-contacts/:id',
        name: 'lists-contacts-detail',
        component: ListDetailPage,
        meta: {
          requiresAuth: true,
          title: 'List Detail',
          requiresNavigationFrom: ['lists-contacts', 'multi-transaction-index'],
        },
      },
      {
        path: '/list-preview',
        name: 'list-preview',
        component: ListPreviewPage,
        meta: {
          requiresAuth: true,
          title: 'List Preview',
          requiresNavigationFrom: ['lists-contacts'],
        },
      },
    ],
  },
];

/** @deprecated Use contactsPrivateRoutes */
export const listsContactsRoutes = contactsPrivateRoutes;
